<div class="contact-container">
  <div class="title-section">
    <hyperkit-typography variant="h3" color="primary">
      Let's Connect
    </hyperkit-typography>
  </div>

  <div class="contact-content">
    <div class="contact-info">
      <div class="headquarters">
        <hyperkit-badge variant="neutral" text="Our Headquarters">
        </hyperkit-badge>
        <hyperkit-typography variant="emphasized" size="sm" color="primary">
          1209 N. Orange Street <br />
          Wilmington, DE. 19801
        </hyperkit-typography>
      </div>

      <div class="email-section">
        <hyperkit-badge variant="neutral" text="Email Us Here">
        </hyperkit-badge>
        <hyperkit-typography variant="emphasized" size="sm" color="primary">
          info&#64;intel471.com
        </hyperkit-typography>
      </div>
      <div class="social-section">
        <hyperkit-badge variant="neutral" text="Follow Us On"> </hyperkit-badge>
        <div class="social-icons">
          <a href="https://x.com/Intel471Inc" target="_blank"
            ><hyperkit-icon
              color="primary"
              size="medium"
              icon="twitter"
            ></hyperkit-icon
          ></a>
          <a href="https://www.linkedin.com/company/intel-471/" target="_blank"
            ><hyperkit-icon color="primary" size="medium" icon="linkedin">
            </hyperkit-icon
          ></a>
        </div>
      </div>
    </div>

    <form
      [formGroup]="contactForm"
      (ngSubmit)="onSendContact()"
      class="contact-form"
    >
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="text"
          id="name"
          label="Your name"
          placeholder="name"
          formControlName="name"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="email"
          id="email"
          label="Email"
          placeholder="email"
          formControlName="email"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="phone"
          id="phone"
          label="Phone"
          placeholder="phone"
          formControlName="phone"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-textarea
          label="Message"
          class="hyperkit-component"
          placeholder="Please leave your message here"
          formControlName="message"
        >
        </hyperkit-textarea>
      </div>
      <hyperkit-error [error]="error"></hyperkit-error>
      <hyperkit-button
        class="submit-btn"
        type="submit"
        size="medium"
        [disabled]="!contactForm.valid"
        color="tertiary"
        text="Send"
      ></hyperkit-button>
    </form>
  </div>
</div>
